"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineReduceProcessor = void 0;
/**
 * The `reduce` processor aggregates and merges logs based on matching keys and merge strategies.
 */
class ObservabilityPipelineReduceProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineReduceProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineReduceProcessor = ObservabilityPipelineReduceProcessor;
/**
 * @ignore
 */
ObservabilityPipelineReduceProcessor.attributeTypeMap = {
    groupBy: {
        baseName: "group_by",
        type: "Array<string>",
        required: true,
    },
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    mergeStrategies: {
        baseName: "merge_strategies",
        type: "Array<ObservabilityPipelineReduceProcessorMergeStrategy>",
        required: true,
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineReduceProcessorType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineReduceProcessor.js.map